module.exports = __webpack_public_path__ + "img/fig13.c10d8b94.jpg";